import React from 'react';
import CategoryList from './CategoryList';
import { data } from './bannerData'
import css from './CategoriesPage.module.css';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink } from '../../components';

const Banner = props => {
  const supportLink = <a href="mailto:info@eventify.lv" rel="noopener noreferrer">info@eventify.lv</a>;

  const bannerItems = data.map(item => {
    return <li style={{ backgroundImage: `url(${item.img})` }} className={css.bannerItem}>
      <h3 className={css.bannerTitle}>{item.title}</h3>
      <h4 className={css.bannerSubTitle}>
        {item.email ?
          <a className={css.link} href="mailto:info@eventify.lv" rel="noopener noreferrer">{item.subTitle}</a> :
          <NamedLink name="NewListingPage" className={css.link}>
            {item.subTitle}
          </NamedLink>
        }


      </h4>
    </li>
  })

  return (
    <ul className={css.bannerList}>
      {bannerItems}
    </ul>
  )
}

Banner.defaultProps = {
  data: [],
};


export default Banner;
